import { render, staticRenderFns } from "./HospitalsData.vue?vue&type=template&id=66fa8f26"
import script from "./HospitalsData.vue?vue&type=script&lang=js"
export * from "./HospitalsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports